document.documentElement.classList.remove('no-js');

(() => {
  const api=window.QXTheme||{};
  const root=api.root||((window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/');
  const qs=api.qs||((s,ctx=document)=>ctx.querySelector(s));
  const qsa=api.qsa||((s,ctx=document)=>[...ctx.querySelectorAll(s)]);
  const qxSafeStorageRead=api.safeStorageRead||((key,validator=()=>true,fallback=null)=>{
    try{
      const raw=localStorage.getItem(key);
      if(raw===null)return fallback;
      const parsed=JSON.parse(raw);
      return validator(parsed)?parsed:fallback;
    }catch(_){return fallback}
  });
  const showUxToast=api.showToast||(()=>{});
  const qxSafeGet=api.safeGet||(async (url,{signal,headers={}}={})=>{
    const response=await fetch(url,{signal,headers:{Accept:'text/html',...headers}});
    if(!response.ok)throw new Error('request-failed');
    return response;
  });

/* Accessible drawers / modal focus management */
  let activeDialog = null;
  let activeDialogTrigger = null;

  const focusableSelector = [
    'a[href]',
    'button:not([disabled])',
    'input:not([disabled])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    '[tabindex]:not([tabindex="-1"])'
  ].join(',');

  const activateDialog = (dialog, trigger) => {
    if (!dialog) return;
    activeDialog = dialog;
    activeDialogTrigger = trigger instanceof HTMLElement ? trigger : document.activeElement;
  };

  const deactivateDialog = (dialog, restoreFocus = true) => {
    if (!dialog || activeDialog !== dialog) return;

    const trigger = activeDialogTrigger;
    activeDialog = null;
    activeDialogTrigger = null;

    if (restoreFocus && trigger instanceof HTMLElement && document.contains(trigger)) {
      setTimeout(() => trigger.focus(), 0);
    }
  };

  const trapDialogFocus = event => {
    if (event.key !== 'Tab' || !activeDialog || !document.contains(activeDialog)) return;

    const items = qsa(focusableSelector, activeDialog)
      .filter(el => {
        if (el.hasAttribute('hidden') || el.getAttribute('aria-hidden') === 'true') return false;
        if (el.closest('[hidden],[aria-hidden="true"]')) return false;
        const style = window.getComputedStyle(el);
        return style.visibility !== 'hidden' && style.display !== 'none' && el.getClientRects().length > 0;
      });

    if (!items.length) {
      event.preventDefault();
      activeDialog.focus?.();
      return;
    }

    const first = items[0];
    const last = items[items.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  };

  /* Mobile navigation */
  const openMenu = trigger => {
    const menu = qs('[data-mobile-menu]');
    if (!menu) return;

    const panel = qs('.qx-mobile-menu__panel', menu);

    menu.classList.add('is-open');
    menu.setAttribute('aria-hidden', 'false');
    document.body.classList.add('qx-nav-open');
    qs('[data-mobile-menu-open]')?.setAttribute('aria-expanded', 'true');

    activateDialog(panel, trigger);
    setTimeout(() => panel?.focus(), 30);
  };

  const closeMenu = (restoreFocus = true) => {
    const menu = qs('[data-mobile-menu]');
    if (!menu) return;

    const panel = qs('.qx-mobile-menu__panel', menu);

    menu.classList.remove('is-open');
    menu.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('qx-nav-open');
    qs('[data-mobile-menu-open]')?.setAttribute('aria-expanded', 'false');

    deactivateDialog(panel, restoreFocus);
  };


  /* Header state, localization and search drawer */
  const initHeader = () => {
    const header = qs('[data-qx-header]');
    if (!header || header.dataset.qxHeaderReady) return;
    header.dataset.qxHeaderReady = 'true';

    let qxLastScrollY = window.scrollY;
    let qxScrollFrame = 0;
    const update = () => {
      const y = Math.max(0, window.scrollY);
      header.classList.toggle('is-scrolled', y > 24);
      document.body.classList.toggle('qx-magic-scrolled', y > 28);
      const desktop = window.matchMedia('(min-width: 990px)').matches;
      const movingDown = y > qxLastScrollY + 5;
      const movingUp = y < qxLastScrollY - 5;
      const overlayOpen = document.body.classList.contains('qx-search-open') || document.body.classList.contains('qx-nav-open') || document.body.classList.contains('qx-cart-open');
      if (!desktop || y < 120 || movingUp || overlayOpen || header.matches(':focus-within')) header.classList.remove('is-nav-collapsed');
      else if (movingDown) header.classList.add('is-nav-collapsed');
      qxLastScrollY = y;
      qxScrollFrame = 0;
    };
    update();
    window.addEventListener('scroll', () => {
      if (!qxScrollFrame) qxScrollFrame = window.requestAnimationFrame(update);
    }, { passive: true });
    window.addEventListener('resize', () => {
      header.classList.remove('is-nav-collapsed');
      qxLastScrollY = window.scrollY;
    }, { passive: true });

    qsa('[data-nav-parent]', header).forEach(parent => {
      const item = parent.closest('.qx-header__nav-item');
      const dropdown = item ? qs('[data-nav-dropdown]', item) : null;
      if (!item || !dropdown) return;

      const open = () => {
        item.classList.add('is-key-open');
        parent.setAttribute('aria-expanded', 'true');
      };

      const close = () => {
        item.classList.remove('is-key-open');
        parent.setAttribute('aria-expanded', 'false');
      };

      const previewTriggers = qsa('[data-nav-preview-trigger]', dropdown);
      const previewPanels = qsa('[data-nav-preview-panel]', dropdown);
      const setPreview = key => {
        if (!previewPanels.length) return;
        const normalizedKey = String(key);
        previewTriggers.forEach(trigger => trigger.classList.toggle('is-preview-active', trigger.dataset.navPreviewTrigger === normalizedKey));
        previewPanels.forEach(panel => panel.classList.toggle('is-active', panel.dataset.navPreviewPanel === normalizedKey));
      };
      if (previewPanels.length) setPreview(previewPanels[0].dataset.navPreviewPanel || '0');
      previewTriggers.forEach(trigger => {
        const activate = () => setPreview(trigger.dataset.navPreviewTrigger || '0');
        trigger.addEventListener('pointerenter', activate);
        trigger.addEventListener('focusin', activate);
      });

      if (window.matchMedia('(min-width: 990px)').matches) {
        let closeTimer = 0;
        item.addEventListener('pointerenter', () => {
          window.clearTimeout(closeTimer);
          open();
        });
        item.addEventListener('pointerleave', () => {
          window.clearTimeout(closeTimer);
          closeTimer = window.setTimeout(close, 90);
        });
        dropdown.addEventListener('pointerenter', () => window.clearTimeout(closeTimer));
      }

      parent.addEventListener('keydown', event => {
        if (event.key === ' ') {
          event.preventDefault();
          if (item.classList.contains('is-key-open')) close();
          else open();
        }

        if (event.key === 'ArrowDown') {
          event.preventDefault();
          open();
          qs(focusableSelector, dropdown)?.focus();
        }

        if (event.key === 'Escape') {
          event.preventDefault();
          close();
          parent.focus();
        }
      });

      item.addEventListener('focusin', open);

      item.addEventListener('focusout', event => {
        if (!item.contains(event.relatedTarget)) close();
      });

      dropdown.addEventListener('keydown', event => {
        if (event.key === 'Escape') {
          event.preventDefault();
          close();
          parent.focus();
        }
      });
    });

    const mobileMenu = qs('[data-mobile-menu]', header);
    if (mobileMenu && !mobileMenu.dataset.qxAccordionReady) {
      mobileMenu.dataset.qxAccordionReady = 'true';
      qsa('details.qx-mobile-menu__level1, details.qx-mobile-menu__level2', mobileMenu).forEach(details => {
        details.addEventListener('toggle', () => {
          if (!details.open) return;
          const selector = details.classList.contains('qx-mobile-menu__level1')
            ? 'details.qx-mobile-menu__level1'
            : 'details.qx-mobile-menu__level2';
          const scope = details.classList.contains('qx-mobile-menu__level1')
            ? details.parentElement
            : details.closest('.qx-mobile-menu__children');
          qsa(selector, scope || mobileMenu).forEach(other => {
            if (other !== details) other.open = false;
          });
        });
      });
    }
  };

  const openSearch = trigger => {
    const drawer = qs('[data-search-drawer]');
    if (!drawer) {
      window.location.href = root + 'search';
      return;
    }

    closeMenu(false);

    const panel = qs('.qx-search-drawer__panel', drawer);

    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('qx-search-open');
    qsa('[data-search-open]').forEach(btn => btn.setAttribute('aria-expanded', 'true'));

    activateDialog(panel, trigger);

    setTimeout(() => qs('[data-predictive-search-input]', drawer)?.focus(), 30);
  };

  const closeSearch = (restoreFocus = true) => {
    const drawer = qs('[data-search-drawer]');
    if (!drawer) return;

    const panel = qs('.qx-search-drawer__panel', drawer);

    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('qx-search-open');
    qsa('[data-search-open]').forEach(btn => btn.setAttribute('aria-expanded', 'false'));

    deactivateDialog(panel, restoreFocus);
  };

  const initPredictiveSearch = () => {
    qsa('[data-predictive-search-input]').forEach(input => {
      if (input.dataset.qxReady) return;
      input.dataset.qxReady = 'true';

      const drawer = input.closest('[data-search-drawer]');
      const results = qs('[data-predictive-search-results]', drawer);
      if (!results) return;

      const initial = results.innerHTML;
      let timeout;
      let controller;
      let activeIndex = -1;
      const responseCache = new Map();

      const options = () => qsa('[data-predictive-option]', results);

      const clearActive = () => {
        options().forEach(option => option.classList.remove('is-keyboard-active'));
        activeIndex = -1;
        input.removeAttribute('aria-activedescendant');
      };

      const setActive = index => {
        const items = options();
        if (!items.length) return;

        activeIndex = (index + items.length) % items.length;
        items.forEach((option, optionIndex) => {
          option.classList.toggle('is-keyboard-active', optionIndex === activeIndex);
        });

        const current = items[activeIndex];
        if (current.id) input.setAttribute('aria-activedescendant', current.id);
        current.scrollIntoView({ block: 'nearest' });
      };

      const setSearchState=state=>{drawer.dataset.qxSearchState=state;['idle','loading','results','empty','error'].forEach(x=>drawer.classList.toggle('is-search-'+x,x===state));};
      const setLoading = loading => { drawer.classList.toggle('is-search-loading', loading); input.setAttribute('aria-busy', loading ? 'true' : 'false'); if(loading)setSearchState('loading'); };

      const restoreInitial = () => {
        controller?.abort();
        results.innerHTML = initial;
        input.setAttribute('aria-expanded', 'false');
        setLoading(false); setSearchState('idle');
        clearActive();
      };

      input.addEventListener('input', () => {
        clearTimeout(timeout);
        const query = input.value.trim();

        if (query.length < 2) {
          restoreInitial();
          return;
        }

        input.setAttribute('aria-expanded', 'true');
        clearActive();

        timeout = setTimeout(async () => {
          controller?.abort();
          controller = new AbortController();
          setLoading(true);

          try {
            const params = new URLSearchParams({
              q: query,
              'resources[type]': 'query,product,collection,page,article',
              'resources[limit]': '4',
              'resources[limit_scope]': 'each',
              'resources[options][unavailable_products]': 'last',
              section_id: 'predictive-search'
            });

            const url = `${root}search/suggest?${params.toString()}`;
            const cacheKey = query.toLowerCase();

            if (responseCache.has(cacheKey)) {
              results.innerHTML = responseCache.get(cacheKey);
              drawer.classList.remove('is-searching');
              setSearchState(results.querySelector('.qx-predictive__empty') ? 'empty' : 'results');
              setLoading(false);
              clearActive();
              return;
            }

            drawer.classList.add('is-searching');
            const response = await qxSafeGet(url, {
              signal: controller.signal,
              timeout: 5500,
              retry: 1,
              headers: { Accept: 'text/html' }
            });
            const html = await response.text();
            responseCache.set(cacheKey, html);
            if (responseCache.size > 24) {
              const oldest = responseCache.keys().next().value;
              responseCache.delete(oldest);
            }
            results.innerHTML = html; drawer.classList.remove('is-searching'); setSearchState(results.querySelector('.qx-predictive__empty')?'empty':'results'); clearActive();
          } catch (error) {
            if (error.name !== 'AbortError') {
              setSearchState('error'); results.innerHTML = '<div class="qx-predictive__empty"><strong>Search suggestions are unavailable</strong><p>Press Enter to continue to full search.</p></div>'; 
            }
          } finally {
            setLoading(false);
          }
        }, 180);
      });

      input.addEventListener('keydown', event => {
        const items = options();

        if (event.key === 'ArrowDown' && items.length) {
          event.preventDefault();
          setActive(activeIndex + 1);
          return;
        }

        if (event.key === 'ArrowUp' && items.length) {
          event.preventDefault();
          setActive(activeIndex - 1);
          return;
        }

        if (event.key === 'Enter' && activeIndex >= 0 && items[activeIndex]) {
          event.preventDefault();
          items[activeIndex].click();
          return;
        }

        if (event.key === 'Escape') {
          if (input.value) {
            input.value = '';
            restoreInitial();
          } else {
            closeSearch();
          }
        }
      });

      results.addEventListener('mousemove', () => clearActive());
    });
  };

const initSearchHistoryDrawer = () => {
    const key = 'qxRecentSearches';
    qsa('[data-search-drawer]').forEach(drawer => {
      const form = qs('.qx-search-drawer__form', drawer);
      const input = form?.querySelector('input[name="q"]');
      const recent = qs('[data-qx-search-recent]', drawer);
      const list = qs('[data-qx-search-recent-list]', drawer);
      const clear = qs('[data-qx-search-recent-clear]', drawer);
      if (!recent || !list || recent.dataset.qxReady === 'true') return;
      recent.dataset.qxReady = 'true';

      const limit = Number(document.documentElement.dataset.qxRecentSearchLimit || 5);
      const read = () => qxSafeStorageRead(key, Array.isArray, []).filter(Boolean);
      const render = () => {
        const terms = read().slice(0, limit);
        list.innerHTML = '';
        terms.forEach(term => {
          const link = document.createElement('a');
          link.href = `${root}search?q=${encodeURIComponent(term)}&type=product,article,page`;
          link.textContent = term;
          list.appendChild(link);
        });
        recent.hidden = terms.length === 0;
      };
      form?.addEventListener('submit', () => {
        const term = input?.value.trim();
        if (!term) return;
        const current = read();
        const next = [term, ...current.filter(item => item.toLowerCase() !== term.toLowerCase())].slice(0, 8);
        try { localStorage.setItem(key, JSON.stringify(next)); } catch (_) {}
      });
      clear?.addEventListener('click', () => {
        try { localStorage.removeItem(key); } catch (_) {}
        render();
        input?.focus();
      });
      render();
    });
  };

let qxVoiceRecognition=null;
  const initVoiceSearch=()=>{const supported=!!(window.SpeechRecognition||window.webkitSpeechRecognition);qsa('[data-qx-voice-search]').forEach(b=>{b.hidden=!supported;b.setAttribute('aria-hidden',supported?'false':'true')})};
  const speakSearch=input=>{const SR=window.SpeechRecognition||window.webkitSpeechRecognition;if(!SR||!input)return;const button=input.closest('[data-search-drawer]')?.querySelector('[data-qx-voice-search]');if(qxVoiceRecognition){try{qxVoiceRecognition.abort()}catch(_){}qxVoiceRecognition=null;button?.classList.remove('is-listening');return}const r=new SR();qxVoiceRecognition=r;r.lang=document.documentElement.lang||'en-US';r.interimResults=false;r.maxAlternatives=1;const done=()=>{button?.classList.remove('is-listening');button?.setAttribute('aria-pressed','false');qxVoiceRecognition=null};button?.classList.add('is-listening');button?.setAttribute('aria-pressed','true');r.onresult=e=>{input.value=e.results?.[0]?.[0]?.transcript||'';input.dispatchEvent(new Event('input',{bubbles:true}));input.focus()};r.onerror=()=>{showUxToast('Voice search could not start');done()};r.onend=done;try{r.start()}catch(_){done();showUxToast('Voice search could not start')}};

  window.QXHeaderShell=Object.assign(window.QXHeaderShell||{},{
    focusableSelector,
    activateDialog,
    deactivateDialog,
    trapDialogFocus,
    openMenu,
    closeMenu,
    initHeader,
    openSearch,
    closeSearch,
    initPredictiveSearch,
    initSearchHistoryDrawer,
    initVoiceSearch,
    speakSearch
  });

  const boot=()=>{
    initHeader();
    initPredictiveSearch();
    initSearchHistoryDrawer();
    initVoiceSearch();
  };

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',boot,{once:true});
  }else{
    boot();
  }

  document.addEventListener('shopify:section:load',boot);
  document.addEventListener('shopify:block:select',boot);
})();
